import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { ISiteNamedUserModel } from '@apps-common/types/portal/users'

export const createSystemUser = async (model: ISiteNamedUserModel): Promise<ISiteNamedUserModel> =>
  axios.post(`/my-monitoring/sites/AddSystemUser`, model).then((res) => res?.data?.data)

type Props = {
  model: ISiteNamedUserModel
}

export const useMyMonitoringCreateSystemUser = (notify?: boolean, onSuccess?: (data: ISiteNamedUserModel) => void) =>
  useMutation({
    mutationKey: ['createMyMonitoringSiteSystemUser'],
    mutationFn: ({ model }: Props) => createSystemUser(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created user.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to create user.')
      }
    },
    throwOnError: false
  })
